import type { Epic } from 'Flux/index.js'
import { isAnyOf } from '@reduxjs/toolkit'
import { filter, map } from 'rxjs/operators'
import { invitationSlice } from '../../Slice/Invitation/InvitationSlice.js'
import { projectSlice } from '../../Slice/Project/ProjectSlice.js'

/** Accepting removes an invite server-side without touching the loaded list, so reload it for the pending count. */
export const RefreshInvitesOnAcceptEpic: Epic = (action$) =>
  action$.pipe(
    filter(isAnyOf(projectSlice.actions.acceptProjectInviteRequestSuccess, invitationSlice.actions.acceptInvitationSuccess)),
    map(() => invitationSlice.actions.getAllInvitesRequest())
  )
